<template>
  <div class="addgroup-form">
    <el-dialog title="新增分组" :visible="addFormShow" width="1200px" @open="dialogOpen" :show-close="false">
      <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="分组名称" label-width="100px" prop="groupName">
          <el-input v-model="ruleForm.groupName" autocomplete="off" placeholder="请输入分组名称"
            style="width: 235px"></el-input>
        </el-form-item>
        <el-form-item label="分组类型" label-width="100px" prop="groupType">
          <el-select v-model="ruleForm.type" placeholder="请选择" @change="groupTypeSelect">
            <el-option v-for="item in groupTypeList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" v-if="preparationSelectShow">
        <el-form-item label="年级列表" label-width="100px" prop="grade">
          <!-- 选择年级 -->
          <el-select v-model="ruleForm.gradeId" placeholder="请选择年级" @change="selectClass">
            <el-option v-for="item in gradeSelectList" :key="item.gradeId" :label="item.gradeName"
              :value="item.gradeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目列表" label-width="100px" prop="course">
          <el-select v-model="ruleForm.courseId" placeholder="请选择">
            <el-option v-for="item in courseList" :key="item.id" :label="item.courseName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent>
        <el-form-item label="教师搜索" label-width="100px">
          <div class="search">
            <search :placeholder="placeholder" @search="search" />
          </div>
        </el-form-item>
      </el-form>
      <div class="table-list">
        <div class="table-item">
          <div>待选择分组成员(选中的第一个成员默认为组长)：</div>
          <el-table :row-key="getRowKeys" ref="table" :data="teacherList" style="width: 100%" height="350px"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
            <el-table-column prop="teacherName" label="姓名" width="180">
              <!-- <template slot="header" slot-scope="scope">
                <el-input v-model="searchVal" size="mini" placeholder="教师姓名搜索" />
              </template> -->
            </el-table-column>
            <el-table-column prop="teacherNumber" label="编号" width="180">
            </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
          </el-table>
        </div>
        <div class="table-item">
          <div>已选择分组成员：</div>
          <el-table :data="selectTeacherList" style="width: 100%" height="350px">
            <el-table-column prop="teacherName" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="teacherNumber" label="编号" width="180">
            </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="form-btn">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  name: "",
  props: ["addFormShow", "teacherList", "groupTypeList", "gradeSelectList", "courseList"],
  data() {
    return {
      ruleForm: {
        groupName: "",
        type: "0",
        gradeId: "",
        courseId: "",
      },
      rules: {
        groupName: [
          { required: true, message: "请输入分组名字", trigger: "blur" },
        ],
      },
      selectList: [],
      placeholder: "请输入教师姓名",
      typeList: [
        {
          label: "备课组",
          value: 0,
        },
        {
          label: "其它",
          value: 1,
        },
      ],
      preparationSelectShow: false,
      selectTeacherList: [],
      searchVal: '',
    };
  },
  components: {
    search,
  },
  created() {
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    selectClass(e) { },
    groupTypeSelect(e) {
      this.preparationSelectShow = e == 1 ? true : false;
    },
    search(query) {
      this.$emit("searchTeacher", query);
    },
    handleSelectionChange(val) {
      // console.log(val);
      // 如果 val 包含所需的信息，则无需赋值给 this.selectList
      const selectedIds = val.map(item => item.id);

      // // 触发事件只需要做一次，并且只传递最终的结果
      this.$emit('multiple', selectedIds);

      // // 如果你需要保存选中的教师列表，可以这样做（根据实际情况决定是否需要）
      this.selectTeacherList = val;
    },
    // 关闭弹出窗口
    dialogClose() {
      this.reset();
      this.$emit("update:addFormShow", false);
    },
    dialogOpen() { },
    confirm() {
      // console.log("this.selectList==>", this.selectList);
      if (this.selectTeacherList.length == 0)
        return this.$message.error("未选择分组成员");
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("formSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm = {
        groupName: "",
        type: "0",
        gradeId: "",
        courseId: "",
      };
      this.preparationSelectShow = false;
      this.$refs.table.clearSelection();
      this.selectTeacherList = [];
      // this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./addgroup-form.scss";
</style>